export default __webpack_public_path__ + "static/media/slider-info-laptop-dark-bottom.91852b5c.svg";